// Extraído do MontadorPistaHipismo.vue — geometria básica

export function pointInPolygon(p, poly){
  let inside = false
  for (let i=0, j=poly.length-1; i<poly.length; j=i++){
    const xi=poly[i].x, yi=poly[i].y, xj=poly[j].x, yj=poly[j].y
    const intersect = ((yi>p.y)!=(yj>p.y)) && (p.x < (xj-xi)*(p.y-yi)/((yj-yi)||1e-9) + xi)
    if (intersect) inside = !inside
  }
  return inside
}

export function closestPointOnSegment(p, a, b){
  const abx=b.x-a.x, aby=b.y-a.y
  const apx=p.x-a.x, apy=p.y-a.y
  const ab2=abx*abx+aby*aby || 1e-9
  let t=(apx*abx+apy*aby)/ab2
  t=Math.max(0, Math.min(1, t))
  return { x: a.x + abx*t, y: a.y + aby*t }
}

export function clampToPolygon(p, poly){
  if (pointInPolygon(p, poly)) return p
  let best=p, bestD=Infinity
  for (let i=0;i<poly.length;i++){
    const a=poly[i], b=poly[(i+1)%poly.length]
    const q=closestPointOnSegment(p,a,b)
    const d=(q.x-p.x)**2 + (q.y-p.y)**2
    if (d<bestD){ bestD=d; best=q }
  }
  return best
}

export function clamp(v, a, b) { return Math.max(a, Math.min(b, v)) }
